export enum WistiaProjectsEnum {
  Investments = 'yx8d4hinkm',
  DevelopmentCenter = 'aja3iokrsx',
  ResourceCenter = 'zye1waua3n',
}